import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalDocument.css";

function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="legal-document">
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By providing your phone number and clicking on the checkbox, you
          expressly consent to receive automated text messages from us at the
          phone number provided. If you do not agree to these terms, please do
          not provide your phone number or use our reservation messaging
          service.
        </p>
      </section>

      <section>
        <h2>2. RCS/SMS Messaging Service</h2>
        <p>
          Our messaging service allows you to receive reservation-related
          communications via RCS/SMS. By providing your phone number, you
          expressly consent to receive automated text messages from us at the
          phone number provided.
        </p>
      </section>

      <section>
        <h2>3. Types of Messages You Will Receive</h2>
        <p>
          We will send you RCS/SMS messages for the following purposes only:
        </p>
        <ul>
          <li>Confirmation when a reservation is successfully made</li>
          <li>Confirmation when a reservation is modified</li>
          <li>Confirmation when a reservation is cancelled</li>
          <li>Requests to confirm upcoming reservations</li>
        </ul>
        <p>
          <strong>
            These messages are transactional in nature and are not marketing
            messages.
          </strong>
        </p>
      </section>

      <section>
        <h2>4. Message Frequency</h2>
        <p>
          Message frequency varies based on your reservation activity. You will
          only receive messages related to reservations you have made or
          modified.
        </p>
      </section>

      <section>
        <h2>5. Consent to Receive Messages</h2>
        <p>
          By providing your phone number and clicking on the checkbox, you
          expressly consent to receive automated text messages from us at the
          phone number provided. Consent is not a condition of making a
          reservation - you may make reservations by phone or in person without
          providing consent to receive text messages.
        </p>
      </section>

      <section>
        <h2>6. Your Responsibilities</h2>
        <p>You agree to:</p>
        <ul>
          <li>Provide accurate contact information</li>
          <li>
            Respond to reservation confirmation requests in a timely manner
          </li>
          <li>Notify us if you need to cancel or modify your reservation</li>
          <li>
            Arrive on time for your reservation or cancel with reasonable notice
          </li>
          <li>Notify us immediately if your phone number changes</li>
        </ul>
      </section>

      <section>
        <h2>7. Cancellations and No-Shows</h2>
        <p>
          Reservations may be cancelled up until the scheduled time. Failure to
          arrive for a reservation without prior cancellation may result in
          restrictions on future bookings.
        </p>
      </section>

      <section>
        <h2>8. Message and Data Rates</h2>
        <p>
          Message and data rates may apply based on your mobile carrier's plan.
          Please contact your mobile carrier for details about your specific
          plan and any charges that may apply.
        </p>
      </section>

      <section>
        <h2>9. Supported Carriers</h2>
        <p>
          Our RCS/SMS service is available on all major U.S. carriers.
          Availability may vary by carrier and device.
        </p>
      </section>

      <section>
        <h2>Opt-Out Instructions</h2>
        <p>
          You may opt out of receiving RCS/SMS messages at any time by replying
          "STOP" to any message. Upon successful opt-out, you will receive a
          confirmation: "You have been successfully unsubscribed."
        </p>
      </section>

      <section>
        <h2>11. Help/Customer Support</h2>
        <p>
          For help or support with our messaging service, reply "HELP" to any
          message or contact us at trattoriademi@gmail.com.
        </p>
      </section>

      <section>
        <h2>12. Modification of Service</h2>
        <p>
          We reserve the right to modify or discontinue the RCS/SMS messaging
          service at any time. We will make reasonable efforts to notify you of
          significant changes.
        </p>
      </section>

      <section>
        <h2>13. Limitation of Liability</h2>
        <p>Our messaging service is provided "as is." We are not liable for:</p>
        <ul>
          <li>Delays in message delivery</li>
          <li>Message delivery failures due to carrier or technical issues</li>
          <li>Any costs incurred from receiving messages</li>
          <li>Service interruptions or technical problems</li>
        </ul>
      </section>

      <section>
        <h2>14. Privacy</h2>
        <p>
          Your privacy is important to us. Please review our{" "}
          <span
            className="legal-link"
            onClick={() => navigate("/reserve/privacy-policy")}
          >
            Privacy Policy
          </span>{" "}
          to understand how we collect, use, and protect your information.
        </p>
      </section>

      <section>
        <h2>15. Changes to Terms</h2>
        <p>
          We may update these Terms of Service periodically. Continued use of
          our messaging service after changes indicates acceptance of the
          modified terms.
        </p>
      </section>

      <section>
        <h2>16. Contact Information</h2>
        <p>
          If you have questions about these Terms of Service, please contact us
          at:
        </p>
        <ul>
          <li>Email: trattoriademi@gmail.com</li>
          <li>Phone: +1(847)-332-2330</li>
          <li>Address: 1571 Sherman Ave, Evanston, IL, 60201</li>
        </ul>
      </section>

      <p className="last-updated">Last Updated: 11/30/25</p>
    </div>
  );
}

export default TermsOfService;
